// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmCancelModal_customerTitle__A3Szl","customerLabel":"ConfirmCancelModal_customerLabel__GTZE8","customerBtn":"ConfirmCancelModal_customerBtn__P9rHH"};